import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Input from '../commons/component/input';
import Button from '../commons/component/button';
import Eye from '../icons/eye-svg';

import { getStepAfterLogin, loginTelemarketer, getErrorMessageByErrorCode } from './entrar-action';

import { pushOrRedirect } from '../commons/query';
import UserIcon from '../icons/user-icon';
import { dispatchLoadEvent } from '../cadastro/metrics';

class EntrarTelemarketer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      isSubmitting: false,
      defaultErrorMessage: 'E-mail ou senha incorretos',
      errorMessage: '',
      password: '',
      email: ''
    };
  }

  componentDidMount() {
    dispatchLoadEvent('telemarketer');
  }

  render() {
    const { showPassword, isSubmitting, errorMessage, password, email } = this.state;

    return (
      <div className="entrar__wrapper --telemarketer">
        <h2 className="entrar-title">
          <UserIcon />
          <span>Identificação do vendedor</span>
        </h2>
        <form onSubmit={this.submitLogin}>
          {errorMessage && <span className="entrar-formError --zeroLeft">{errorMessage}</span>}
          <label className="entrar-inputBlock --column" id="emai">
            <label className="entrar-inputLabel">Login de vendedor</label>
            <Input
              id="email-input"
              name="email"
              type="text"
              value={email}
              placeholder="Ex. joaodasilva@gmail.com"
              className="entrar-input form-control"
              data-page="login"
              data-form="login"
              onChange={this.handleChange.bind(this)}
              disabled={isSubmitting}
              required
            />
          </label>
          <label className="entrar-inputBlock --column --passwordInput" id="password">
            <label className="entrar-inputLabel">Senha</label>
            <div className="entrar-input__wrapper">
              <Input
                id="password-input"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                data-page="login"
                data-form="login"
                className="entrar-input --hasAddon form-control"
                autoComplete={false}
                onChange={this.handleChange.bind(this)}
                disabled={isSubmitting}
                required
              />
              <span onClick={this.toggleShowPassword} className="entrar-inputAddon">
                <Eye on={!showPassword} />
              </span>
            </div>
          </label>

          <Button
            id="login-button"
            primary
            disabled={isSubmitting}
            loading={isSubmitting}
            className="entrar-button"
          >
            Continuar
          </Button>
        </form>
      </div>
    );
  }

  handleChange = ({ target }) => {
    const { name, value } = target;
    this.setState({
      [name]: value
    });
  };

  toggleShowPassword = () => {
    this.setState(state => ({
      showPassword: !state.showPassword
    }));
  };

  turnLoadingOn = () => {
    this.setState({
      isSubmitting: true,
      errorMessage: ''
    });
  };

  turnLoadingOff = () => {
    this.setState({
      isSubmitting: false,
      errorMessage: ''
    });
  };

  setErrorMessage = ({ errorCode }) => {
    this.setState(state => ({
      errorMessage: getErrorMessageByErrorCode(errorCode, state.defaultErrorMessage)
    }));
  };

  redirect = url => {
    return e => {
      e.preventDefault();
      pushOrRedirect(this.props.history.push, {
        url: url,
        push: true
      });
    };
  };

  submitLogin = event => {
    event.preventDefault();
    this.turnLoadingOn();

    loginTelemarketer({
      username: this.state.email,
      password: this.state.password
    })
      .then(() => {
        this.turnLoadingOff();
        return getStepAfterLogin({});
      })
      .then(pushOrRedirect(this.props.history.push))
      .catch(error => {
        this.turnLoadingOff();
        this.setErrorMessage(error);
      });
  };
}

export default withRouter(EntrarTelemarketer);
